import { useEffect, useState } from 'react';
import { INotification } from '../models/INotification';
import { Alert } from '@orbita-ui/core';
import { NotificationItemContainer } from './Notification.styles';

export const Notification = ({ notification }: { notification: INotification }) => {
  const [isVisible, setIsVisible] = useState<boolean>(true);
  const { time, message, type } = notification;
  useEffect(() => {
    setTimeout(() => {
      setIsVisible(false);
    }, time);
  }, [time]);

  return (
    <NotificationItemContainer>
      {isVisible ? (
        <Alert
          subtitle={message}
          variant={type}
          withCloseIcon
          fullWidth
          isShown={isVisible}
          closeIconOnclick={() => setIsVisible(false)}
        />
      ) : (
        <></>
      )}
    </NotificationItemContainer>
  );
};
